import { Arbeitsbereich } from '@/domain/mitarbeiter/features/anlageassistent/entities/Arbeitsbereich';
import { GET_MITARBEITER_ARBEITSBEREICHE_BY_STANDORTID } from '@/domain/mitarbeiter/features/anlageassistent/hooks/useArbeitsbereiche/graphql/queries';
import {
  Mitarbeiter_GetArbeitsbereicheByStandortIdQuery,
  Mitarbeiter_GetArbeitsbereicheByStandortIdQueryVariables,
} from '@/gql/graphql';
import { useSuspenseQuery } from '@apollo/client/react';
import * as Sentry from '@sentry/react';

export function useArbeitsbereiche(standortId: string): {
  arbeitsbereiche: Arbeitsbereich[];
} {
  const result = useSuspenseQuery<
    Mitarbeiter_GetArbeitsbereicheByStandortIdQuery,
    Mitarbeiter_GetArbeitsbereicheByStandortIdQueryVariables
  >(GET_MITARBEITER_ARBEITSBEREICHE_BY_STANDORTID, {
    variables: { standortId },
  });

  if (result.error) {
    Sentry.captureException(result.error);
    return { arbeitsbereiche: [] };
  }

  return {
    arbeitsbereiche:
      result.data?.mitarbeiter_arbeitsbereicheByStandortIds.map(
        (a) =>
          new Arbeitsbereich({
            id: a.id,
            name: a.name,
            markierung: a.markierung,
            standortId,
          }),
      ) || [],
  };
}
